<template>
  <span
    class="link"
    :class="{ u: underline }"
    :style="{ '--u-offset': `${underlineOffset}px` }"
  >
    <span class="link__text" ref="link">
      <slot />
    </span>
  </span>
</template>

<script setup>
const { $SplitText: SplitText } = useNuxtApp();

let splitted;
let splittedMask;
const link = ref(null);
const { registerSplitText } = useAnimationCleanup();

const setupMultiline = () => {
  // Cleanup previous SplitText instance
  if (splitted) {
    splitted.revert();
  }

  setTimeout(() => {
    splitted = new SplitText(link.value, {
      type: 'lines',
      mask: 'lines',
      linesClass: 'link-line',
    });

    // Register for cleanup
    registerSplitText(splitted);

    splitted.lines.forEach((line, i) => {
      line.dataset.label = line.textContent;
      line.style.setProperty('--label', `"${line.textContent}"`);

      line.style.setProperty('--index', i);
      line.classList.add(props.align);
    });
  }, 0);
};

const props = defineProps({
  text: { type: String, default: null },
  to: { type: String, default: null },
  href: { type: String, default: null },
  underline: { type: Boolean, default: false },
  align: { type: String, default: 'ta-c' },
  underlineOffset: { type: Number, default: 0 },
});

onMounted(() => {
  setupMultiline();
});
</script>

<style lang="scss" scoped>
.link {
  cursor: pointer;
  display: inline-flex;
  line-height: 100%;
  position: relative;
  width: fit-content;
  height: fit-content;

  &.u {
    padding-bottom: 0.15em;
  }

  &:hover:before {
    left: 0;
    transform-origin: right;
    transform: scaleX(0);
  }

  &.u:before {
    content: '';
  }

  &:before {
    background: currentColor;
    bottom: 0;
    height: 0.1em;
    left: 0;
    pointer-events: none;
    position: absolute;
    right: 0;
    transform-origin: left;
    transition: transform 1s ease(outExpo);
    width: 100%;
  }

  &:hover:deep(.link-line) {
    transform: translateY(-120%);
  }

  &:deep(.link-line) {
    display: inline-flex;
    position: relative;
    transition: transform 1s ease(outExpo) calc(0.1s * var(--index));
    width: 100%;
    line-height: 100%;

    &:after {
      bottom: -120%;
      content: attr(data-label);
      left: 0;
      position: absolute;
    }
  }

  &:deep(.line-mask) {
    clip-path: inset(0% 0 -10% 0);
  }
}
</style>
